import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { TextField, TextFieldSkeleton } from 'components/shared/TextField/TextField';
import { CurrencyFlagIcon, WithCountryFlag } from 'components/shared/WithCountryFlag';
import { FC } from 'react';

interface OwnProps {
  value?: string;
  isDisabled: boolean;
  isLoading: boolean;
}

export const Currency: FC<OwnProps> = ({ value, isDisabled, isLoading }) => {
  return (
    <BlockOrientationFormGroup inputId="currency" label="tradeAllocation.edit.currency">
      {isLoading && !value && <TextFieldSkeleton />}
      {(!isLoading || value) && (
        <WithCountryFlag content={value ? <CurrencyFlagIcon currency={value} /> : undefined}>
          <TextField id="currency" value={value} isReadOnly isDisabled={isDisabled} />
        </WithCountryFlag>
      )}
    </BlockOrientationFormGroup>
  );
};

Currency.displayName = 'Currency';
